const breakpoints = {
  bpLarge: '1024px',
  bpMedium: '760px',
  bpSmall: '480px',
};

module.exports = breakpoints;
